import { Stack, Tooltip } from '@mui/material';

import { TextLink } from '@/components/shared/textLink';

interface DbLinkProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataLocation: any;
  resourceId: string;
}

export const DBLink = (props: DbLinkProps) => {
  const { dataLocation, resourceId } = props;

  if (dataLocation?.sql) {
    // Truncate SQL for display, show full in tooltip
    const sql = String(dataLocation.sql);
    const truncatedSql = sql.length > 60 ? `${sql.slice(0, 60)}...` : sql;
    // Example DB Explorer link, adjust path/query as needed
    const dbExplorerUrl = `/db/${resourceId}?query=${encodeURIComponent(sql)}`;
    return (
      <Tooltip title={sql}>
        <TextLink href={dbExplorerUrl}>{truncatedSql}</TextLink>
      </Tooltip>
    );
  }
  if (dataLocation?.database || dataLocation?.table || dataLocation?.column) {
    return (
      <Stack direction='row' alignItems='center' divider={<>.</>}>
        {dataLocation?.database && (
          <Tooltip title='Database Name'>
            <span>[{dataLocation?.database}]</span>
          </Tooltip>
        )}
        {dataLocation?.table && (
          <Tooltip title='Table Name'>
            <span>[{dataLocation?.table}]</span>
          </Tooltip>
        )}
        {dataLocation?.column && (
          <Tooltip title='Column Name'>
            <span>[{dataLocation?.column}]</span>
          </Tooltip>
        )}
      </Stack>
    );
  }
};
